import React, { useEffect, useState } from 'react';
import styles from './LangSelector.module.css';
import en from 'assets/images/lang/en.svg';
import ru from 'assets/images/lang/ru.svg';
import ua from 'assets/images/lang/ua.svg';
import pt from 'assets/images/lang/pt.svg';
import es from 'assets/images/lang/es.svg';
import ArrowDown from 'assets/images/icons/arrow-down.svg';
import ArrowDownDark from 'assets/images/icons/arrow-down_dark.svg';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

const LangSelector = ({
  variant='light', // light | dark
  className,
  withIcon=true,
}) => {
  const [selectedLanguage, setSelectedLanguage] = useState(0);
  const { i18n } = useTranslation();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const langs = [
    {name:'Eng', img: en, value: 'en'},
    {name:'Rus', img: ru, value: 'ru'},
    {name:'Ukr', img: ua, value: 'ua'},
    {name:'Por', img: pt, value: 'pt'},
    {name:'Esl', img: es, value: 'es'},
  ];

  useEffect(() => {
    const langMatch = pathname.match(/^\/(en|ru|ua|pt|es)\b/);

    if (langMatch) {
      const lang = langMatch ? langMatch[1] : 'en';
      setSelectedLanguage(langs.findIndex(l => l.value === lang));
    } else {
      setSelectedLanguage(0);
    }
  }, []);

  const handleLanguageChange = index => {
    setSelectedLanguage(index);
    i18n.changeLanguage(langs[index].value);

    // const newUrl = `/${langs[index].value}${window.location.pathname.slice(3)}`;
    navigate(`/${langs[index].value}${window.location.pathname.slice(3)}`);
    // window.history.pushState({}, null, newUrl);
  };

  const [isOpen, setIsOpen] = useState(false)
  return (
    <div 
      className={`${styles.langSelector} ${styles[variant]} ${className}`}
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <span>{langs[selectedLanguage].name}</span>
      <img src={variant === 'light' ? ArrowDown : ArrowDownDark} />

      {isOpen && <div className={styles.dropdownBlock}/>}

      {isOpen && 
      <div className={`${styles.dropdownWrapper} ${styles[variant]}`}>
        {langs.map((lang, index) => 
          <div key={index} className={styles.dropdownLang} onClick={() => handleLanguageChange(index)}>
            <p className={styles.langName}>{lang.name}</p>
          </div>
        )}
      </div>}

    </div>
  );
};

export default LangSelector;
